<sm-title-bar pageTitle="Referral"></sm-title-bar>

<!-- <sm-title-bar pageTitle="Businesses"></sm-title-bar> -->

<mat-card appearance="outlined" *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="messageList" 
       [showPagination]="true" [itemsPerPage]="5" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate">
      </sm-data-table>
    </div>
  </mat-card>

  <div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>
  
  
  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View referee details</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 'Used'" (click)="activateDeactivateReferralCode(rowvalue.hash_id,0)">
      <mat-icon class="material-icons-outlined">badge</mat-icon>
      <span>Activate</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 'Unused'" (click)="activateDeactivateReferralCode(rowvalue.hash_id,1)">
      <mat-icon class="material-icons-outlined">inventory</mat-icon>
      <span>De-activate</span>
    </button>
   
  </ng-template>